/* 🤖 this file was generated by svg-to-ts */
export const matIconList: {
  name: 'list';
  data: string;
} = {
  name: 'list',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/></svg>`
};
